
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface PlansFooterProps {
  language: Language;
}

const PlansFooter: React.FC<PlansFooterProps> = ({ language }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="py-3 bg-slate-50 dark:bg-white/[0.02] border-t border-slate-200 dark:border-white/5 text-center">
       <span className="text-[9px] text-slate-400 font-bold flex items-center justify-center gap-2">
         <i className="fas fa-lock text-emerald-500/50"></i> {t.secure}
       </span>
    </div>
  );
};

export default PlansFooter;
